import React from 'react';

import GeneralRiskImpactCategoryCreateForm from './GeneralRiskImpactCategoryCreateForm';

import ModalHeader from 'CommonComponents/ModalHeader';

export default function GeneralRiskImpactCategoryCreateModal(props) {
    const close = () => {
        props.modalElement.hide();
    };

    const onCreated = () => {
        close();
        props.onCreated();
    };

    return (
        <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div className="modal__container">
                <div className="modal__inner-container">
                    <ModalHeader title={$t('Add General Risk Impact Category')} close={close}></ModalHeader>
                    <div className="tw-rounded-b">
                        <div className="modal__form-container">
                            <GeneralRiskImpactCategoryCreateForm storeUrl={props.storeUrl} onSuccess={onCreated} onCancel={close} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
